import React from "react";

function Timeline({ mission, userMissionState }) {
    return (
        <div className="timeline-container">
            {mission.timeline.map((state, index) => {
                const active = state.active_statuses.includes(userMissionState);
                const completed = state.completed_statuses.includes(userMissionState);
                return (
                    <TimelineState stateName={state.name} index={index} active={active} completed={completed} lastItem={index === mission.timeline.length - 1} key={index} />
                )
            })}
        </div>
    )
}

function TimelineState({ stateName, index, active, completed, lastItem = false }) {
    const isFirstItem = index === 0;
    const isLastItem = lastItem;

    const timelineBackgroundLineClass = `timeline-background-line ${isFirstItem ? "timeline-background-line-first" : ""} ${isLastItem ? "timeline-background-line-last" : ""}`;

    return (
        <div className="timeline-item">
            <TimelineCircle index={index} active={active} completed={completed} />
            <div className="timeline-item-text body-small">{stateName}</div>
            <div className={timelineBackgroundLineClass} />
        </div>
    )
}

function TimelineCircle({ index, active, completed }) {
    const isActive = active;
    const isCompleted = completed;

    const circleClass = `timeline-circle ${isActive ? "active" : ""} ${isCompleted ? "completed" : ""} `;

    const checkmark = (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M5.08496 11.1468L9.41509 13.6468L13.9151 5.85254" stroke="white" strokeWidth="1.5" />
        </svg>
    )

    return (
        <div className={circleClass}>
            {isCompleted ? checkmark : <div className="timeline-circle-text">{index + 1}</div>}
        </div>
    )
}

export default Timeline;